import { ICreateAndUpdateSuperAgent } from "../../../types/superAgent.interface";
import customAxios from "../../customAxios";
import { UPDATE_SUPER_AGENT } from "../../routes";

const updateSuperAgent = async (formData: ICreateAndUpdateSuperAgent) => {
  try {
    return (
      await customAxios.put(UPDATE_SUPER_AGENT + `/${formData._id}`, {
        ...formData,
        city: formData.city?._id,
        province: formData.province?._id,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_SUPER_AGENT: error });
    return false;
  }
};

export default updateSuperAgent;
